import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import { issueTypeTone } from './issueTypeTag.constants';
import styles from '../styles/status-pill-tag.module.scss';

/**
 * Tag for the TYPE column of an issue-tracker table — the same chip language as
 * `TransactionTypeTag`, over the same shared stylesheet.
 *
 * The type is served as the tracker's own word (`Story`, `Task`, `Bug`) and is
 * rendered as sent rather than translated: there is no mapping table for types,
 * only for statuses. Only the casing is ours.
 *
 * @param {Object} props
 * @param {string} [props.type]
 */
function IssueTypeTag({ type }) {
    const tone = issueTypeTone(type);
    // Uppercased in the DOM, not only by `text-transform`: the accessible name a
    // screen reader announces and the string a test or a bug report copies both
    // come from the text node, so the casing has to be real rather than painted
    // on. `status-pill-tag.module.scss` then agrees with it instead of changing it.
    const label = (type || '').toString().toUpperCase();

    if (!label) return null;

    return (
        <Text
            as={TextAs.SPAN}
            size={TextSizes.EXTRA_SMALL}
            data-tone={tone}
            className={`${styles.tag} ${styles[`tone_${tone}`]}`}
        >
            {label}
        </Text>
    );
}

export default IssueTypeTag;
